import React from 'react';
import styled, { css } from 'styled-components';
import { layout, margin, padding, border, position } from 'styled-system';
import {
  string,
  node,
  number,
  oneOfType,
  arrayOf,
  object,
  func,
} from 'prop-types';
import { useProgressiveImage } from '../../utils';

export const objectFit = css`
  object-fit: ${({ objectFit: value }) => `${value}`};
`;

const StyledImage = styled.img`
  ${layout};
  ${margin};
  ${padding};
  ${objectFit};
  ${border};
  ${position};
  overflow: hidden;
`;

function Image({ src, fallbackContent, onLoad, ...restProps }) {
  const imageSource = useProgressiveImage({
    src,
    fallbackSrc: '',
  });
  const showFallbackContent = !imageSource && fallbackContent;

  if (showFallbackContent) {
    return fallbackContent;
  }

  return <StyledImage src={imageSource} onLoad={onLoad} {...restProps} />;
}

Image.defaultProps = {
  width: 1,
  height: '100%',
  objectFit: 'cover',
  src: '',
  fallbackContent: null,
};

Image.propTypes = {
  width: oneOfType([string, number, arrayOf(string), arrayOf(number)]),
  height: oneOfType([string, number, arrayOf(string), arrayOf(number)]),
  src: oneOfType([string, object]),
  fallbackContent: node,
  onLoad: func,
  objectFit: string,
};

export default Image;
